import { useCallback } from 'react';
import { useAuthContext } from '@picsart/growth-rc/AuthContext';

var useTokenData = function useTokenData() {
  var _useAuthContext = useAuthContext(),
    tokenDataRef = _useAuthContext.tokenDataRef;
  var getAccessToken = useCallback(function () {
    var _tokenDataRef$current;
    return tokenDataRef === null || tokenDataRef === void 0 || (_tokenDataRef$current = tokenDataRef.current) === null || _tokenDataRef$current === void 0 ? void 0 : _tokenDataRef$current.access_token;
  }, [tokenDataRef]);
  return {
    getAccessToken: getAccessToken
  };
};

export { useTokenData as default };
//# sourceMappingURL=index.js.map
